<template>
    <div class="cash-detail-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
        </div>
        <el-tabs type="border-card" tab-position="top" @tab-click="handleClick" v-model="tabSel">
            <el-tab-pane label="优惠券批次管理" name="tab0">
                <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
                    <el-button size="small" type="danger" @click="updateOrAddCashticketBatch(form)">{{ticketBatchId==0?'下一步':'保 存'}}</el-button>
                </div>
                <el-form :model="form" label-width="120px" size="small ">
                    <el-form-item label="举例注意">
                        <el-alert title="如果生成类型选择优惠码，生成优惠码总数为100, 兑换/发送次数为20，最多领取为30 表示：总共生成100个兑换码，每个兑换码可以兑换20次，本批次共可以兑换2000次，但是每个用户只可以领取30次" type="success" :closable="false">
                        </el-alert>
                    </el-form-item>
                    <el-form-item label="批次标识">
                        <el-input v-model="form.ticketBatchId" placeholder="无需输入" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="批次名称" :required="true">
                        <el-input v-model="form.ticketBatchName" placeholder="批次名称" clearable ></el-input>
                    </el-form-item>
                    <el-form-item label="金额类型" :required="true">
                        <el-select :popper-append-to-body="true" v-model="form.ticketType">
                            <el-option
                                v-for="item in ticketTypeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="抵扣类型">
                        <el-select v-model="form.applyTo" clearable filterable>
                            <el-option
                                    v-for="item in cashApplyToEnum"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="批次状态">
                        <el-select :popper-append-to-body="true" v-model="form.status">
                            <el-option
                                v-for="item in statuseList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="批次分类">
                        <el-select :popper-append-to-body="true" v-model="form.ticetClass" filterable>
                            <el-option
                                v-for="item in getTicetClassList"
                                :key="item.dictionaryKey"
                                :label="item.dictionaryName"
                                :value="item.dictionaryKey">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否可见">
                        <el-select :popper-append-to-body="true" v-model="form.userVisible">
                            <el-option
                                v-for="item in userVisibleList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item label="是否数字">
                        <el-select :popper-append-to-body="false" v-model="form.digital">
                            <el-option
                                    v-for="item in digitalList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>-->
                    <el-form-item label="生成类型"  :required="true">
                        <el-select :popper-append-to-body="true" :disabled="allowEdit" v-model="form.createType"  filterable @change="changeCreateType">
                            <el-option
                                v-for="item in cashCreateTypeEnum"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span style="color: red">由用户手工兑换的优惠券请选择创建时生成券码(如员工券、客服补发券),除此以外的选领取时生成券码</span>
                    </el-form-item>

                    <el-form-item label="优惠码" v-show="ticketNo_show">
                        <el-input v-model="form.ticketNo" placeholder="优惠码" maxlength="10" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="优惠券总数" v-show="false" :required="true">
                        <el-input-number v-model="form.ticketNoNum" :min="0" :max="1000000"  label="优惠券总数"></el-input-number>
                        <span style="color: red">*优惠券总数量</span>
                    </el-form-item>
                    <el-form-item label="位数" v-show="(form.createType==2||form.createType==1)">
                        <el-input-number v-model="form.ticketPosition" :min="1" :max="12" label="位数"></el-input-number>
                    </el-form-item>
                    <el-form-item label="优惠方式" :required="true">
                        <el-select :popper-append-to-body="true" :disabled="allowEdit" v-model="form.discountMode" filterable @change="changeDiscountMode">
                            <el-option
                                v-for="item in cashDiscountModeEnum"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="叠加使用" :required="true">
                        <el-select :popper-append-to-body="true" :disabled="canEditComposeUse" v-model="form.composeUse" filterable clear >
                            <el-option
                                v-for="item in composeUseList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span style="color: red">选择可叠加使用，同一个订单最多允许同时使用两张券</span>
                    </el-form-item>
                    <el-form-item label="优惠券金额" v-show="amount_show" :required="true">
                        <el-input-number v-model="form.amount"  :disabled="allowEdit" :min="0" :max="10000" label="优惠券金额"></el-input-number>
                        <span style="color: red">*优惠券金额</span>
                    </el-form-item>
                    <el-form-item label="折扣" v-show="discountAmount_show">
                        <el-input-number v-model="form.discountAmount" :min="0" :step="1" :max="100" label="折扣"></el-input-number>
                    </el-form-item>
                    <el-form-item label="满多少可用" :required="true">
                        <el-input-number v-model="form.minUseamount" :min="0" :max="5000" label="满多少可用"></el-input-number>
                        <span style="color: red">无门槛填写0</span>
                    </el-form-item>
                    <el-form-item label="优惠券数量" :required="true">
                        <el-input-number v-model="form.quantity" :min="0" :max="1000000" :step="1" label="优惠券数量"></el-input-number>
                    </el-form-item>
                    <el-form-item label="跳转url" >
                        <el-input v-model="form.cashUseUrl" placeholder="e.g https://wx.lechun.cc" ></el-input>
                        <span style="color: red">商城优惠券列表点立即使用要跳转的连接 通用券不用填写，默认跳转商城首页</span>
                    </el-form-item>
                    <el-form-item label="期限">
                        <el-select :popper-append-to-body="false" v-model="form.periodType" @change="changePeriodType">
                            <el-option
                                v-for="item in periodTypeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="天数" v-show="days_show">
                        <el-input-number v-model="form.days" :min="1" :step="1" :max="1000" label="天数"></el-input-number>
                        <span style="color: red">不算兑换当天噢~~</span>
                    </el-form-item>
                    <el-form-item label="开始日期" v-show="beginTime_show">
                        <el-date-picker
                            v-model="form.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" v-show="endTime_show">
                        <el-date-picker
                            v-model="form.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="最多领取" :required="true">
                        <el-input-number v-model="form.userTackCount" :min="0" :step="1" :max="10000"  label="最多领取 0无限制"></el-input-number>
                        <span style="color: red">*每个用户最多可以领取数量~~</span>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="2" placeholder="会显示在优惠劵列表" v-model="form.remark"></el-input>
                        <span style="color: red">*显示在优惠劵列表 标注使用规则</span>
                    </el-form-item>
                </el-form>

            </el-tab-pane>
            <el-tab-pane label="优惠券使用规则" v-if="ticketBatchId!=0" name="tab1">
                <el-form :inline="true" :model="formInline2" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item>
                        <el-button type="success" @click="handleAdd2">新增规则</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList2" stripe border center :size="GCONFIG.styleTabFleSize">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="ruleId" label="标示"></el-table-column>
                    <el-table-column prop="ruleTypeName" label="规则类型"></el-table-column>
                    <el-table-column prop="stats" label="规则(对象能否用券)">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.stats" clearable filterable >
                                <el-option
                                        v-for="item in ruleStatusList"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="detailIdNames" label="详情"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="180">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button type="primary" :disabled="scope.row.ruleType==8" v-show="false" size="mini" @click="saveCashRule(scope.row)">保存</el-button>
                                <el-button type="danger" size="mini" @click="deleteCashRule(scope.row)">删除</el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                        background
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="formInline2.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline2.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline2.recordsTotal">
                    </el-pagination>
                </div>
                <cashProductRule :dialogFormVisible="dialogFormVisible" @closeRuleDialog="closeRuleDialog"></cashProductRule>

            </el-tab-pane>
            <el-tab-pane label="优惠券领取列表" v-if="ticketBatchId!=0" name="tab2">
                <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item label="优惠码">
                        <el-input v-model="formInline1.ticketNo" placeholder="优惠码"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="formInline1.status" clearable filterable>
                            <el-option
                                v-for="item in cashStatusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getCouponList">查询</el-button>
                        <el-button type="success" @click="downloadCashticketList">导出</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="ticketId" label="标示"></el-table-column>
                    <el-table-column prop="ticketName" label="名称"></el-table-column>
                    <el-table-column prop="ticketNo" label="优惠券(码)号"></el-table-column>
                    <el-table-column prop="ticketAmount" label="金额"></el-table-column>
                    <el-table-column prop="discountAmount" label="折扣"></el-table-column>
                    <el-table-column prop="codeStatusName" label="优惠券状态"></el-table-column>
                    <el-table-column prop="activtionCount" label="已激活数量"></el-table-column>
                    <el-table-column prop="cashStatusName" label="使用状态"></el-table-column>
                    <el-table-column prop="orderMainNo" label="母订单号"></el-table-column>
                    <el-table-column prop="createTime" label="创建日期	"></el-table-column>
                    <el-table-column prop="usedTime" label="使用时间"></el-table-column>
                    <el-table-column prop="beginTime" label="有效期(开始)"></el-table-column>
                    <el-table-column prop="endTime" label="有效期(结束)"></el-table-column>
                    <el-table-column prop="realyDeduction" label="使用金额"></el-table-column>
                    <el-table-column prop="nickName" label="领取人"></el-table-column>
                    <el-table-column prop="totalAmount" label="订单总金额"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="80">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" v-if="scope.row.codeStatus==1 || scope.row.codeStatus==0" @click="updateCashticketStatus(scope.row)">禁用</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import cashProductRule from '@/components/coupon/cashProductRule'
    import {
        getCashticketDetail,
        getQueryList,
        updateOrAddCashticketBatch,
        getCashticketStatusList,
        getCashticketGetList,
        updateCashticketStatus,
        getCashRuleStatusList,
        getCashticketBatchUseRuleList,
        saveCashRule,
        deleteCashRule,
        saveCashRuleStats,
        setCashCache,
        downloadCashticketListApi
    } from '../../api/api'

    //定义组件
    export default {
        components:{
            cashProductRule
        },
        data() {
            return {
                tabSel:'tab0',
                ruleTabSel:'tab0',
                ruleTabs:[
                    {label:'单品',value:'6'},
                    {label:'套装',value:'2'},
                    {label:'促销',value:'3'},
                    {label:'运输方式',value:'7'},
                    {label:'平台',value:'5'},
                    {label:'产品类目',value:'8'},
                ],
                ticketBatchId:this.$route.query.cashId,
                getCashticketBatchList: [],
                cashCreateTypeEnum: [],
                cashDiscountModeEnum: [],
                cashApplyToEnum: [],
                getTicetClassList: [],
                cashStatusList: [],
                getProductList:[],
                getPromotionList:[],
                getGroupList:[],
                platFormList:[],
                dataList1:[],
                dataList2:[],
                getCashRuleTypeList:[],
                ticketTypeList: [{value: 0, name: '固定金额'}, {value: 1, name: '可变金额'}],
                periodTypeList: [{value: 1, name: '日期'}, {value: 2, name: '天数'}],
                statuseList: [{value: 1, name: '启用'}, {value: 0, name: '禁用'}],
                statusRuleList: [{value: 1, name: '全部可用'}, {value: 3, name: '部分可用'}],
                userVisibleList: [{value: 1, name: '可见'}, {value: 0, name: '不可见'}],
                digitalList: [{value: 1, name: '数字'}, {value: 0, name: '混合'}],
                composeUseList: [{value: 0, name: '不可叠加使用'},{value: 1, name: '可叠加使用'}],
                loading: true,
                dialogFormVisible: false,
                ticketNoNum_show:false,
                ticketNo_show:false,
                beginTime_show:false,
                endTime_show:false,
                days_show:true,
                discountAmount_show:false,
                createType_show:false,
                allowEdit:false,
                amount_show:true,
                showProduct: false,
                showPromotion: false,
                showGroup: false,
                showVip: false,
                productActive:false,
                groupActive:false,
                promotionActive:false,
                pingtaiActive:false,
                transportActive:false,
                productClassActive:false,
                canEditComposeUse:false,
                ruleTab:6,
                ruleStatusList: [], // 或者初始化为其他适合的数据类型
                form: {
                    ticketBatchId: '',
                    ticketBatchName: '',
                    ticketType: 0,
                    createType: 3,
                    ticketPosition: 8,
                    minUseamount:0,
                    quantity: 100,
                    discountMode:0,
                    discountAmount: 100,
                    amount: 0,
                    periodType: 2,
                    days: 7,
                    userTackCount: 1,
                    remark: '',
                    status: 1,
                    ticetClass: '',
                    ticketNoNum: 1,
                    applyTo:2,
                    userVisible: 1,
                    digital: 1,
                    cashUseUrl:'',
                    beginTime:'',
                    endTime:'',
                    composeUse:0
                },
                formInline: {
                    ticketBatchId: "",
                    ticketBatchName: "",
                    createType: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
                formInline1:{
                    ticketBatchId: "",
                    ticketNo:'',
                    status:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline2:{
                    ticketBatchId: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form1: {
                    ticketBatchId: '',
                    stats: '',
                    ruleType: '',
                    products: [],
                    groups:[],
                    platforms: [],
                    proms: [],
                },
            }
        },
        //挂载时候执行
        mounted() {
            if(this.ticketBatchId){
                this.formInline1.ticketBatchId = this.ticketBatchId
                this.formInline2.ticketBatchId = this.ticketBatchId
                this.initCouponDetail();
                this.getCouponList();
                this.getRuleList();
                this.getCashRuleStatusList()
            }

            getQueryList({}).then((res) => {
                this.cashCreateTypeEnum = res.data.value.cashCreateTypeEnum;
                this.cashCreateTypeEnum.pop();
                this.cashDiscountModeEnum = res.data.value.cashDiscountModeEnum;
                this.getTicetClassList = res.data.value.ticetClassList;
                this.cashApplyToEnum = res.data.value.cashApplyToEnum;
                for (let i = 0; i < this.getTicetClassList.length; i++) {
                    this.getTicetClassList[i].dictionaryKey=parseInt(this.getTicetClassList[i].dictionaryKey);
                }
            });
            getCashticketStatusList({}).then((res) => {
                this.cashStatusList = res.data.value;
            });
            this.productActive=true;
        },
        methods: {
            initCouponDetail(){
                getCashticketDetail({ticketBatchId:this.ticketBatchId}).then(res=>{
                    console.log('detail',res)
                    this.form = res.data.value
                })
            },
            convertStatusRule(row, column, cellValue){
                if (cellValue == 1) {
                    return "全部可用";
                } else if (cellValue == -1) {
                    return "全部可用";
                } else {
                    return "部分可用";
                }
            },
            getCashRuleStatusList(){
                this.loading = true;
                getCashRuleStatusList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleStatusList = res.data.value;
                    }
                })
            },
            getCashRuleStatusList(){
                this.loading = true;
                getCashRuleStatusList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleStatusList = res.data.value;
                    }
                })
            },
            updateOrAddCashticketBatch(form) {
                var type="^[0-9]*[1-9][0-9]*$";
                var re = new RegExp(type);
                var flag=re.test(form.amount);
//                if(form.discountMode == 0 && !flag){
//                    this.$message({
//                        showClose: true,
//                        message: '优惠券金额应为正整数!',
//                        type: 'success'
//                    });
//                    return false;
//                }
//                var flag2=re.test(form.discountAmount);
//                if(form.discountMode == 1 && !flag2){
//                    this.$message({
//                        showClose: true,
//                        message: '优惠券折扣应为0-99的正整数',
//                        type: 'success'
//                    });
//                    return false;
//                }
                if(form.discountMode == 1 && (form.discountAmount < 0 || form.discountAmount >= 100)) {
                    this.$message({
                        showClose: true,
                        message: '优惠券折扣应为0-99的正整数!',
                        type: 'success'
                    });
                    return false;
                }
                if(this.form.periodType==1){
                    this.form.beginTime=this.form.beginTime+' 00:00:00';
                    this.form.endTime=this.form.endTime+' 00:00:00';
                }
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateOrAddCashticketBatch(form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        if(this.ticketBatchId==0){
                            this.ticketBatchId = res.data.value.ticketBatchId
                            this.formInline1.ticketBatchId = this.ticketBatchId
                            this.formInline2.ticketBatchId = this.ticketBatchId
                            this.getCouponList();
                            this.getRuleList();
                            this.$router.push({name: 'CashBathDetail',params:{id:this.ticketBatchId},query:{cashId:this.ticketBatchId}})

                        }
                        this.tabSel = 'tab1'
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            changeCreateType(newValue) {
                if (newValue == '1') {
                    //兑换码
                    this.ticketNoNum_show = true;
                    this.ticketNo_show=true;

                } else {
                    //优惠劵
                    this.ticketNoNum_show = false;
                    this.ticketNo_show=false;
                }
            },
            changeDiscountMode(newValue) {
                if (newValue == '0') {
                    //满减
                    this.discountAmount_show = false;
                    this.amount_show = true;
                    this.canEditComposeUse=false;
                } else if (newValue == '1') {
                    //折扣
                    this.discountAmount_show = true;
                    this.form.composeUse=0;
                    this.canEditComposeUse=true;
                    this.amount_show = false;
                }
            },
            changePeriodType(newValue) {
                if (newValue == '1') {
                    //日期
                    this.beginTime_show = true;
                    this.endTime_show = true;
                    this.days_show = false;

                } else if (newValue == '2') {
                    //天数
                    this.beginTime_show = false;
                    this.endTime_show = false;
                    this.days_show = true;
                }
            },
            getCouponList() {
                getCashticketGetList(this.formInline1).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.getCouponList()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.getCouponList()
            },
            updateCashticketStatus(row) {
                this.$confirm('禁用优惠劵, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    updateCashticketStatus({ticketId: row.ticketId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getCouponList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            setCashCache4Old(){
                setCashCache().then((res) => {});
            },
            downloadCashticketList(){
                window.open(`${downloadCashticketListApi}?ticketBatchId=${this.formInline1.ticketBatchId}&status=${this.formInline1.status}&pageSize=99999&currentPage=${this.formInline1.currentPage}&pageRouterUrl=prizelist`)
            },
            //定义查询方法
            getRuleList() {
                getCashticketBatchUseRuleList(this.formInline2).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline2.recordsTotal = res.data.value.total;
                        this.dataList2 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange2(val) {
                this.formInline2.pageSize = val;
                this.getRuleList()
            },
            handleCurrentChange2(val) {
                this.formInline2.currentPage = val;
                this.getRuleList()
            },
            //定义查询方法
            saveCashRule(row) {
                saveCashRuleStats(row).then((res) => {
                    if (res.data.status == 200) {
                        this.getRuleList()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteCashRule(row) {
                this.$confirm('删除规则, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteCashRule({ruleId: row.ruleId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getRuleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            handleAdd2(row) {
                this.dialogFormVisible = true;
            },
            handleClick(tab, event) {

            },
            closeRuleDialog(showStatus){
                this.dialogFormVisible = showStatus;
                this.getRuleList();
            },
            returnHistory(){
                window.history.go(-1)
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.cash-detail-wrap{
    padding: 10px 20px;
    .header-return{
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
    }
    .header-btn{
        float: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/cash/cashBathDetail.vue